import { Stack, Container, Typography, Box } from '@mui/material';
import { ChangePasswordForm } from 'src/sections/authentication/changePassword';
import AuthBrandPanel from '../components/authentication/AuthBrandPanel';
import { AuthRootStyle, AuthSectionStyle, AuthContentStyle } from '../components/authentication/authLayoutStyles';

export default function ChangePassword() {
  return (
    <AuthRootStyle title={`Change Password | ${process.env.REACT_APP_PROJECTNAME}`}>
      <AuthSectionStyle sx={{ display: { xs: 'none', md: 'flex' } }}>
        <AuthBrandPanel />
      </AuthSectionStyle>

      <Container maxWidth="sm">
        <AuthContentStyle>
          <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'center', mb: 4 }}>
            <AuthBrandPanel compact />
          </Box>

          <Stack sx={{ mb: 3 }}>
            <Typography className="heading_center" sx={{ color: '#F3F4F6 !important' }} variant="h5" gutterBottom>
              Set a new password
            </Typography>
            <Typography className="heading_center" sx={{ color: '#9CA3AF !important' }}>
              Choose a strong password you have not used here before.
            </Typography>
          </Stack>

          <ChangePasswordForm />
        </AuthContentStyle>
      </Container>
    </AuthRootStyle>
  );
}
